<template>
  <v-container fluid class="sign-form">
    <v-row>
      <v-col sm="12" md="4" cols="12">
        <v-card align="center" class="signup-card">
          <a href="/" title="Britecheck.com">
            <img class="logo-img" src="@/assets/images/logo-britecheck.svg" width="220" height="36" alt="Britecheck">
          </a>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="login-main">
      <v-col sm="12" md="12" cols="12">
        <v-row justify="center">
          <v-col sm="12" md="4" lg="4" cols="12" style="padding: unset">
            <v-card-subtitle align="center" class="login-subtitle">Set Password</v-card-subtitle>
            <v-card-text align="center" class="login-welcome">Please set your password</v-card-text>
          </v-col>
        </v-row>
        <v-row justify="center" id="reset-container">
          <v-col sm="12" md="5" lg="4" cols="12" style="padding: unset">
            <v-card align="center">
              <SetPasswordForm class="signup-form" />
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SetPasswordForm from '@/components/user/SetPasswordForm'
export default {
  name: 'SetPassword',
  components: {
    SetPasswordForm
  }
}
</script>

<style lang="css">
  .signup-card {
    height: 100%;
    margin: unset;
    border-radius: unset !important;
    background-color: #f5f5f5 !important;
    box-shadow: none !important;;
  }
.body--light {
    background: whitesmoke;
  }
.signup-form {
  background-color: #f5f5f5 !important;
}
#resetpass-card {
    height: 100%;
    margin: unset;
    border-radius: unset !important;
    background-color: #f5f5f5 !important;
    box-shadow: none !important;
}
#reset-subtitle {
  margin-top: 20px;
  font-size: 20px;
  font-weight: 500;
  font-family: 'Source Sans 3', sans-serif;
  color: #302d3e;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}

@media screen and (max-width: 768px) {
  .signup-card {
    padding-left: 2%;
    padding-right: 2%;
  }
  .signup-img {
    display: none;
  }
}
</style>
